import {lazyRegister} from "@/Core/lazyRegister";

lazyRegister.directive('wsDatepicker', [
    '$filter',
    function ($filter) {
        return {
            restrict: "A",
            require: "ngModel",
            link: function (scope, element, attrs, ngModel) {
                element.attr('type', 'date');

                ngModel.$formatters.push(function (value) {
                    if (value) {
                        const date = new Date(value);

                        if (!isNaN(date.getTime())) {
                            return $filter('date')(date, 'yyyy-MM-dd');
                        }
                    }
                    return '';
                });

                ngModel.$parsers.push(function (value) {
                    return value; //? new Date(value) : null;
                });
            }
        };
    }
]);
